import { z } from 'zod';
/**
 * Results of a check (development paper §10, §14.2; ADR-003).
 * "Not conclusive", "case review required" and "technical error" are results in their own
 * right – a technical error is never an inconspicuous check status.
 */
export const CheckResult = z.enum([
    'fulfilled',
    'not_fulfilled',
    'not_conclusive',
    'case_review_required',
    'technical_error',
]);
export const checkResultLabel = {
    fulfilled: 'erfüllt',
    not_fulfilled: 'nicht erfüllt',
    not_conclusive: 'nicht abschließend beurteilbar',
    case_review_required: 'Einzelfallprüfung erforderlich',
    technical_error: 'technischer Fehler',
};
/** Legal obligation of the firm or of a mandate (NEONEWTON 4, obligation matrix). */
export const ObligationLevel = z.enum(['firm', 'mandate']);
export const ObligationStatus = z
    .enum(['applicable', 'conditional_clarify', 'not_applicable'])
    .meta({ id: 'ObligationStatus' });
export const obligationStatusLabel = {
    applicable: 'einschlägig',
    conditional_clarify: 'bedingt – Klärung nötig',
    not_applicable: 'nicht einschlägig',
};
//# sourceMappingURL=checks.js.map